import React from 'react'
import PropTypes from 'prop-types'

const LoadingIndicator = ({ isVisible, size, ...otherProps }) => {
    if (!isVisible) {
        return null
    }

    return (
        <div className="be-spinner" { ...otherProps }>
            <svg width={ `${size}px` } height={ `${size}px` } viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle fill="none" strokeWidth="5" strokeLinecap="round" cx="33" cy="33" r="30" className="circle" />
            </svg>
        </div>
    )
}

LoadingIndicator.propTypes = {
    isVisible : PropTypes.bool,
    size      : PropTypes.number
}

LoadingIndicator.defaultProps = {
    isVisible : false,
    size      : 30
}

export default LoadingIndicator
